export default __webpack_public_path__ + "static/media/282.9ef67ce2.png";